import {
  UPDATE_TEMP_STATE,
  UPDATE_APPLICANT
} from '../../actionTypes';

// js utility library
import _ from 'lodash';

export const initialState = {
  tempState: {}
};

function applicantApplicationReducer(state = initialState, {
  type,
  newTempState
}) {
  switch (type) {
    case UPDATE_TEMP_STATE :
      return _.merge({}, newTempState);

    case UPDATE_APPLICANT :
      return {};

    default:
      return state;
  }
}

export default applicantApplicationReducer;



// WEBPACK FOOTER //
// ./shared/redux/reducers/tempState/index.js